import { useEffect, useState } from "react";
import styles from "./SimpleSlider.module.css";

interface ISimpleSliderProps {
  carouselImages: any;
  isAutoplay: boolean;
  isLanding?: boolean;
}

const SimpleSlider = (SimpleSliderProps: ISimpleSliderProps) => {
  const { isAutoplay, carouselImages, isLanding } = SimpleSliderProps;
  const [slideIndex, setSlideIndex] = useState(1);

  // future requiremnent

  // const onClickPrev = () => {
  //   if (slideIndex === 1) {
  //     setSlideIndex(carouselImages.length);
  //   } else if (slideIndex <= carouselImages.length) {
  //     setSlideIndex(slideIndex - 1);
  //   }
  // };

  // const onClickNext = () => {
  //   if (slideIndex === carouselImages.length) {
  //     setSlideIndex(1);
  //   } else if (slideIndex <= carouselImages.length) {
  //     setSlideIndex(slideIndex + 1);
  //   }
  // };

  useEffect(() => {
    if (isAutoplay) {
      const timer = setInterval(autoPlay, 3000);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [slideIndex]);

  const autoPlay = () => {
    if (slideIndex === carouselImages.length) {
      setSlideIndex(1);
    } else if (slideIndex <= carouselImages.length) {
      setSlideIndex(slideIndex + 1);
    }
  };

  const onClickOnIndicators = (value: number) => {
    setSlideIndex(value);
  };

  return (
    <div className={styles["slider-container"]}>
      {carouselImages?.map((data: any, dataInex: any) => {
        if (slideIndex === dataInex + 1) {
          return (
            <div key={dataInex} className={styles["slider-image-container"]}>
              <img
                src={data?.src}
                alt="login-pic"
                className={isLanding ? null : styles["slider-image"]}
                style={isLanding ? { width: "80%", margin: "auto" } : {}}
              />
              <div className={styles["image-description"]}>
                <span className={styles["header-text"]}>
                  {data?.headerText}
                </span>
                <span className={styles["description"]}>
                  {data?.description}
                </span>
              </div>
            </div>
          );
        }
      })}
      <div className={styles["image-indicators"]}>
        {carouselImages?.map((dot: any, dotIndex: any) => {
          return (
            <span
              key={dotIndex}
              className={
                styles[
                  dotIndex + 1 === slideIndex
                    ? "selected-dot"
                    : "un-selected-dot"
                ]
              }
              onClick={() => onClickOnIndicators(dotIndex + 1)}
            ></span>
          );
        })}
      </div>
    </div>
  );
};

export default SimpleSlider;
